// Firebase configuration and authentication service
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
  updateProfile,
  updateEmail,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider
} from 'firebase/auth';

// Firebase configuration (same as Laravel frontend)
const firebaseConfig = {
  apiKey: "AIzaSyBUJXBN1jmC4BMBg5I6QA_DpBKhuNfqGx0",
  authDomain: "kids-place.firebaseapp.com",
  databaseURL: "https://kids-place.firebaseio.com",
  projectId: "kids-place",
  storageBucket: "kids-place.appspot.com",
  messagingSenderId: "376371791920",
  appId: "1:376371791920:web:3240095ed1be8b99aac5f5",
  measurementId: "G-XMVJ4YDSNE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Email/Password Authentication
export const signInWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const signUpWithEmail = async (email, password, displayName) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    
    // Update profile with display name
    if (displayName) {
      await updateProfile(userCredential.user, { displayName });
    }
    
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Google Sign-In
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return { success: true, user: result.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Sign Out
export const signOutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Password Reset
export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Auth State Observer
export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Get current user
export const getCurrentUser = () => {
  return auth.currentUser;
};

// Update User Profile
export const updateUserProfile = async (displayName, email) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      return { success: false, error: 'No user logged in' };
    }

    const updates = {};
    if (displayName !== undefined) {
      updates.displayName = displayName;
    }
    if (email !== undefined && email !== user.email) {
      updates.email = email;
    }

    await updateProfile(user, updates);
    
    if (email !== undefined && email !== user.email) {
      await updateEmail(user, email);
    }

    return { success: true, user: user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Change Password
export const changeUserPassword = async (currentPassword, newPassword) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      return { success: false, error: 'No user logged in' };
    }

    // Re-authenticate user before changing password
    const credential = EmailAuthProvider.credential(user.email, currentPassword);
    await reauthenticateWithCredential(user, credential);
    
    // Change password
    await updatePassword(user, newPassword);
    
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Get current user's ID token
export const getIdToken = async () => {
  try {
    const user = auth.currentUser;
    if (!user) {
      return null;
    }
    const idToken = await user.getIdToken();
    return idToken;
  } catch (error) {
    console.error('Error getting ID token:', error);
    return null;
  }
};

export { auth }; 